/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CameraViewMode {
    AllScreens = 0,
    Screen1 = 1,
    Screen2 = 2,
    Screen3 = 3,
    Screen4 = 4,
    Screen5 = 5,
    Screen6 = 6,
    Screen7 = 7,
    Screen8 = 8,
    Screen9 = 9,
}
